import React, { Component } from "react";
import config from "../../config";
import utilityFunctions from "../../store/utilityFunctions";
import errorFunctions from "../../store/errorFunctions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Modal from "react-modal";
import ServiceCenterSettingAdd from "./ServiceCenterSettingAdd";
import { MdClose } from "react-icons/md";
import "../common.css";

export default class DefaultSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      serviceCenters: null,
      selectedServiceCenter: null,
      showServiceCenterAdd: false,
    };
  }
  componentDidMount() {
    this.retrieveDefaultServiceCenter();
  }
  retrieveDefaultServiceCenter = () => {
    this.setState({ loading: true });
    utilityFunctions
      .protectedFetch(config.backendServer + "default-service-centers/", "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({ loading: false, serviceCenters: res });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  deleteServiceCenterSetting = async () => {
    this.setState({ loading: true });
    const userInfo = localStorage.getItem("userInfo") || utilityFunctions.getCookie("userInfo");
    const token = userInfo?.access_token || JSON.parse(userInfo)?.access_token;
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    const url = config.backendServer + "default-service-center/" + this.state.serviceCenterCentralId + "/";
    fetch(url, options)
      .then(async (resp) => {
        if (resp.status === 406) {
          const errorMsg = await resp.json();
          alert(errorMsg.message);
        } else if (resp.status === 204) alert("Delete success");
        this.setState({ loading: false, showDeleteModal: false });
        this.retrieveDefaultServiceCenter();
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <div className="page">
        <div className="row my-2">
          <div className="col-8">Service Center Setting</div>
          <div className="col text-end">
            <button
              disabled={this.props.userInfo.user.role !== "Admin"}
              className="btn btn-outline-primary  btn-sm "
              onClick={() =>
                this.setState({
                  showServiceCenterAdd: true,
                  selectedServiceCenter: null,
                })
              }
            >
              Add New
            </button>
          </div>
        </div>
        <TableContainer component={Paper}>
          <Table aria-labelledby="tableTitle" size={"small"} aria-label="enhanced table">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 170 }}>Service Center</TableCell>
                <TableCell style={{ width: 170 }}>Location</TableCell>
                <TableCell style={{ width: 170 }}>Site Name</TableCell>
                <TableCell style={{ width: 70 }}>Country</TableCell>
                <TableCell className="text-end"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.serviceCenters?.map((s, i) => {
                return (
                  <TableRow key={i} className={this.state.serviceCenterCentralId === s.id ? "font-weight-bold bg-light" : ""}>
                    <TableCell className="text-break">{s.service_center_central_name}</TableCell>
                    <TableCell className="text-break">{s.service_center_name}</TableCell>
                    <TableCell className="text-break">{s.site_name}</TableCell>
                    <TableCell className="text-break">{s.country}</TableCell>
                    <TableCell
                      style={{
                        width: "120px",
                        wordWrap: "break-word",
                      }}
                    >
                      <div className="flex justify-stretch">
                        <button
                          className={"btn btn-outline-primary btn-sm m-1"}
                          onClick={() => this.setState({ selectedServiceCenter: s, showServiceCenterAdd: true })}
                        >
                          Edit
                        </button>
                        <button
                          disabled={this.props.userInfo?.user.role !== "Admin"}
                          className={"btn btn-outline-danger btn-sm m-1"}
                          onClick={() =>
                            this.setState({
                              showDeleteModal: true,
                              serviceCenterCentralName: s.name,
                              serviceCenterCentralId: s.id,
                              country: s.country,
                            })
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Modal isOpen={this.state.showServiceCenterAdd} className={"input-modal-mid "}>
          <button onClick={() => this.setState({ showDeleteModal: false })} className={"info-modal-close"}>
            <MdClose />
          </button>
          <ServiceCenterSettingAdd
            closeModal={() => this.setState({ showServiceCenterAdd: false })}
            retrieveDefaultServiceCenter={() => this.retrieveDefaultServiceCenter()}
            userInfo={this.props.userInfo}
            serviceCenterValue={{
              value: this.state.selectedServiceCenter?.service_center_central,
              label: this.state.selectedServiceCenter?.service_center_central_name,
            }}
            locationValue={{
              value: this.state.selectedServiceCenter?.service_center,
              label: this.state.selectedServiceCenter?.service_center_name,
            }}
            siteValue={{
              value: this.state.selectedServiceCenter?.site,
              label: this.state.selectedServiceCenter?.site_name,
            }}
          />
        </Modal>
        <Modal isOpen={this.state.showDeleteModal} contentLabel={"Add New Service Center."} className={"input-modal"}>
          <button onClick={() => this.setState({ showDeleteModal: false })} className={"info-modal-close"}>
            <MdClose />
          </button>
          <div className="card">
            <div className="card-header">Service Center</div>
            <div className="card-body">
              <div className="mb-3">
                <label className={"single-warranty-details-label"}>Do you realy want to delete {this.state.serviceCenterCentralName}</label>
              </div>
            </div>
            <div className="card-footer">
              <button
                className="k-btn k-btn-outline-primary mr-3 k-btn-sm"
                onClick={() => {
                  this.deleteServiceCenterSetting();
                }}
              >
                Delete
              </button>
              <button className="k-btn k-btn-outline-primary  k-btn-sm" onClick={() => this.setState({ showDeleteModal: false })}>
                Close
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
